import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';
import store from '@/store';
import ManagerService from '../../api/ManagerService';

export class LoadBusinessList implements IRouterMiddleware {
  private managerService = new ManagerService();
  private routes = new Set([
    'new-merchant-connect-select-business',
    'merchant-connect-select-business',
    'bo-select-business'
  ]);

  canActivate(to: MiddlewareRoute, from: MiddlewareRoute): boolean {
    return to.name && !!this.managerService.getCredentials()
      ? this.routes.has(to.name)
      : false;
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    const response = await this.managerService.getBusinessList();
    await store.dispatch('manager/SET_BUSINESS_LIST', response.data);
    next();
  }
}
